export default __webpack_public_path__ + "static/media/kiem_tra_doi_chieu_1.95b972c5.png";